import {createReducer, on} from '@ngrx/store';
import {newsArticleStateInitial} from './news-article.state.initial';
import {NewsArticleActions} from './news-article.actions';
import {NewsEntitiesActions} from '../../../../store/action/news-entities.actions';


export const newsArticleReducer = createReducer(
  newsArticleStateInitial,

  on(
    NewsArticleActions.readLatestNews,
    (state) => ({
      ...state,
      latestNewsLoading: true,
      errorLatestNews: undefined,
    }),
  ),

  on(
    NewsArticleActions.readLatestNewsSuccess,
    (state, {newsDtos, totalElements}) => ({
      ...state,
      latestNewsIds: newsDtos.filter(newsDto => !!newsDto.id).map(newsDto => newsDto.id!),
      latestNewsTotalElements: totalElements,
      latestNewsLoaded: true,
      latestNewsLoading: false,
      latestNewsError: undefined,
    }),
  ),

  on(
    NewsArticleActions.readLatestNewsFailure,
    (state, {error}) => ({
      ...state,
      latestNewsLoading: false,
      latestNewsLoaded: false,
      latestNewsIds: [],
      latestNewsError: error,
    }),
  ),

  on(
    NewsEntitiesActions.getNewsById,
    (state, {newsId}) => ({
      ...state,
      currentNewsError: undefined,
      currentNewsLoading: true,
    }),
  ),

  on(
    NewsEntitiesActions.getNewsByIdSuccess,
    (state) => ({
      ...state,
      currentNewsLoading: false,
      currentNewsLoaded: true,
      currentNewsError: undefined,
    }),
  ),

  on(
    NewsEntitiesActions.getNewsByIdFailure,
    (state, {error}) => ({
      ...state,
      currentNewsLoading: false,
      currentNewsLoaded: false,
      currentNewsId: undefined,
      currentNewsError: error,
    }),
  ),

  on(
    NewsArticleActions.changeLatestNewsPageable,
    (state, {latestNewsPageable}) => ({
      ...state,
      latestNewsPageable,
    }),
  ),

  on(
    NewsArticleActions.updateCurrentNewsId,
    (state, {currentNewsId}) => ({
      ...state,
      currentNewsId,
    })
  ),

);
